"use client";

import { useEffect, useState } from "react";

import AnimationComponent from "../../../components/new_components/animation";
import { ReactComponent as ArrowRight } from "../../../public/svg/ArrowRight2.svg";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { APIClient } from "../../../helpers/api_helper";
import * as url from "../../../helpers/url_helper";
import { statusReferrals } from "../../../utils/referrals/status";
import { bonusReferrals } from "../../../utils/referrals/bonus";
import { useCreditStore } from "../../../store/creditStore/creditUserStore";
import { stepsCreditStore } from "../../../store/creditStore/stepsCreditStore";
import { creditOfferStore } from "../../../store/creditStore/offerCreditStore";
import { userBankStore } from "../../../store/creditStore/userBankStore";
import getInstanceAxios from "../../../services/axiosInstance";
import { trackTiktokSignedPixel } from "../../../services/utmleads/utmReferral";

let api = new APIClient();
let axiosInstance = getInstanceAxios();

const BienvenidoPage = ({ isDesktop }) => {
  const navigate = useNavigate();
  const { clearSteps } = stepsCreditStore();
  const { clearOfertCredit } = creditOfferStore();
  const { loadUser, clearUser } = useCreditStore();
  const { clearUserBank } = userBankStore();

  const [isMobile, setIsMobile] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [disbursementDay, setDisbursementDay] = useState("");
  const micuenta = () => {
    setIsLoading(true);
    clearSteps();
    clearOfertCredit();
    clearUser();
    clearUserBank();
    setTimeout(() => {
      setIsLoading(false);
      navigate("/micredito");
    }, 7000);
  };

  const handleReferrals = async () => {
    let utm_id = localStorage.getItem("utm_id");
    if (utm_id) {
      if (utm_id.includes("referido")) {
        let idParent = utm_id.split("-")[1];
        let documento = localStorage.getItem("doc");
        let credit_id = localStorage.getItem("credit_id");
        let status = statusReferrals.CF;
        let bonus = bonusReferrals.CF;
        try {
          let responseApi = await api.create(url.CREATE_REFERRALS, {
            payload: { idParent, documento, credit_id, status, bonus },
          });
          console.log(responseApi.data);
          return;
        } catch (e) {
          console.log(e);
          return;
        }
      }
    }
  };

  const getDayDisbursement = async () => {
    const dayAfter = moment(new Date(), "DD/MM/YYYY").add(1, "days");
    let holidays = [];

    try {
      const holyDaysResponse = await axiosInstance.get(
        url.GET_HOLIDAYS + dayAfter.format("YYYY"),
      );

      holidays = Array.isArray(holyDaysResponse.data?.holidays)
        ? holyDaysResponse.data.holidays.map((h) =>
            moment(h.date, "YYYY-MM-DD").format("YYYY-MM-DD"),
          )
        : [];
    } catch (error) {
      console.warn(
        "[BienvenidoPage] No fue posible consultar los festivos. Se calculará el próximo día hábil sin esa información.",
        error,
      );
    }

    let nextWorkingDay = dayAfter.clone();

    const dayName = dayAfter.format("dddd");

    if (dayName === "sábado") {
      nextWorkingDay.add(2, "days");
    } else if (dayName === "domingo") {
      nextWorkingDay.add(1, "days");
    }

    // 🟡 Validación SOLO de festivos
    while (holidays.includes(nextWorkingDay.format("YYYY-MM-DD"))) {
      nextWorkingDay.add(1, "days");
    }

    const finalDayName = nextWorkingDay.format("dddd");
    const finalDayNumber = nextWorkingDay.format("DD");
    const finalMonthName = nextWorkingDay.format("MMMM");

    return `${finalDayName} ${finalDayNumber} ${finalMonthName}`;
  };

  useEffect(() => {
    handleReferrals();
    void trackTiktokSignedPixel({
      creditId: localStorage.getItem("credit_id"),
    });
    localStorage.setItem("fromConfirmed", "true");
  }, []);

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkIfMobile();

    window.addEventListener("resize", checkIfMobile);
  }, []);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  useEffect(() => {
    const fetchDay = async () => {
      try {
        const result = await getDayDisbursement();
        setDisbursementDay(result);
      } catch (error) {
        console.error(
          "[BienvenidoPage] No fue posible calcular el día de desembolso.",
          error,
        );
      }
    };

    fetchDay();
  }, []);

  return (
    <div>
      <div
        className={`transition-all duration-300 ease-in-out opacity-100 transform translate-x-0`}
        style={{
          height: !isDesktop && "84vh",
          display: "grid",
          placeContent: "center",
        }}
      >
        <div
          className="space-y-6"
          style={{
            // height: !isDesktop && "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            className="bg-muted rounded-lg space-y-3 flex flex-col justify-center items-center"
            style={{ height: "100%" }}
          >
            <AnimationComponent
              animationUrl="/animations/emoji.riv"
              width={isMobile ? "36rem" : "30rem"}
              height={isMobile ? "16rem" : "15rem"}
              heightContainer={isMobile ? "16rem" : "15rem"}
              isDesktop={!isMobile}
            />
            <div>
              <p
                className="font-bold2"
                style={{
                  color: "#C9B8FF",
                  textAlign: "center",
                  fontSize: "55px",
                  width: isDesktop ? "500px" : "350px",
                }}
              >
                Tu crédito viajando hacia a ti
              </p>
              <p
                className="items-center text-center"
                style={{
                  color: "#FAFAFA",
                  width: isDesktop ? "500px" : "350px",
                  height: "auto",
                  fontSize: "16px",
                }}
              >
                {`El desembolso de tu crédito está en proceso y deberías verlo en
                la cuenta que nos dejaste, el plazo maximo es el ${disbursementDay}`}
              </p>
            </div>
          </div>

          <div
            className="flex flex-col px-5"
            style={{
              width: isDesktop ? "280px" : "400px",
              display: !isDesktop && "flex",
              alignItems: !isDesktop && "center",
            }}
          >
            <div
              className="w-full flex gap-4 flex-row sm:flex-row"
              style={{
                alignSelf: "center",
              }}
            >
              <button
                type="button"
                onClick={() => {
                  micuenta();
                }}
                disabled={isLoading}
                style={{
                  height: "70px",
                  borderRadius: "2.5rem",
                  fontSize: "1.2rem",
                  fontWeight: "400",
                  width: isDesktop && "300px",
                  cursor: !isLoading ? "pointer" : "not-allowed",
                  backgroundColor: !isLoading ? "#7E02FC" : "#2C2447",
                }}
                className={`flex items-center justify-center gap-3 px-4 py-3 transition-all duration-200 flex-1 font-medium text-base ${
                  !isLoading
                    ? "text-white hover:bg-purpleDark"
                    : "text-gray-500 cursor-not-allowed"
                }`}
              >
                {isLoading ? (
                  <>
                    <div className="w-6 h-6 border-2 border-current border-t-transparent rounded-full animate-spin" />
                    Viajando...
                  </>
                ) : (
                  <>
                    <p style={{ fontSize: "1.3rem" }}>{"Ir a mi cuenta"}</p>
                    <ArrowRight className="w-8 h-8" />
                  </>
                )}
              </button>
            </div>

            {!isDesktop && (
              <p
                className="text-center text-grayP"
                style={{
                  fontSize: "0.65rem",
                  margin: "15px 30px 0px",
                  lineHeight: "normal",
                  color: "#E1DFE5",
                  letterSpacing: "0.5px",
                }}
              >
                Galilea es una marca de GRUPO EMPRESARIAL ANAV S.A.S GEAA
                registrada en Colombia con NIT: 901.582.748-5
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BienvenidoPage;
